// extracted by mini-css-extract-plugin
module.exports = {"ShipList":"styles_ShipList__3vaT_","ShipsCollected":"styles_ShipsCollected__1adSO","NoResults":"styles_NoResults__3xrb0"};